var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSky(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7273 0H3.27273C1.46525 0 0 1.46525 0 3.27273V20.7273C0 22.5347 1.46525 24 3.27273 24H20.7273C22.5347 24 24 22.5347 24 20.7273V3.27273C24 1.46525 22.5347 0 20.7273 0Z",
    fill: "#1185FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46821 6.44237C9.30257 7.81093 11.2756 10.5858 12 12.0749C12.7245 10.5859 14.6975 7.8109 16.5319 6.44237C17.8555 5.45488 20 4.69081 20 7.12211C20 7.60768 19.7199 11.2011 19.5556 11.7845C18.9844 13.8127 16.9033 14.33 15.0521 14.0169C18.288 14.5642 19.1111 16.3771 17.3334 18.1899C13.9572 21.6329 12.4808 17.3261 12.1023 16.2225C12.0329 16.0202 12.0005 15.9256 12 16.006C11.9995 15.9256 11.9671 16.0202 11.8977 16.2225C11.5194 17.3261 10.043 21.633 6.66658 18.1899C4.88882 16.3771 5.71196 14.5641 8.94786 14.0169C7.09662 14.33 5.01547 13.8127 4.44444 11.7845C4.28013 11.201 4 7.60762 4 7.12211C4 4.69081 6.14469 5.45488 7.46821 6.44237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSky);
export default __webpack_public_path__ + "static/media/blueSky.c6553026fbcb51c6f07f0bedc2d295b4.svg";
export { ForwardRef as ReactComponent };